// extracted by mini-css-extract-plugin
module.exports = {"container":"_2RxOSDrZ","registerButton":"_3mi85IOX"};